export default __webpack_public_path__ + "static/media/arrowleft.5e40a9ab.svg";